export default __webpack_public_path__ + "static/media/brain.d9979778.png";